<template>
    <div class="m-3" style="height: 90vh">
      <ReportsTable
        ref="rtable"
        :columns="columnDefs"
        :settings="{title: t('vendorsOutstandingBalances')}"
        endpoint="reports/vendor/outstanding-balances"
        @onDataLoaded="onDataLoaded"
      >
        <template #cards>
          <div class="grid grid-cols-2 gap-4">
            <el-card shadow="never">
              <div class="flex flex-col items-center">
                <div class="text-lg text-gray-500">{{ t('totalBalances') }}</div>
                <div class="text-2xl pt-2">{{ formatMoney(totalBalances, 'IQD') }}</div>
              </div>
            </el-card>
            <el-card shadow="never">
              <div class="flex flex-col items-center">
                <div class="text-lg text-gray-500">{{ t('totalVendorsWithBalances') }}</div>
                <div class="text-2xl pt-2">{{ totalVendorsWithBalances }}</div>
              </div>
            </el-card>
          </div>
        </template>
      </ReportsTable>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, onBeforeMount, provide } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { ColDef } from 'ag-grid-community'
  import { useRoute, useRouter } from 'vue-router'
  import { useHTTP } from '@/plugins/http'
  import { useAlertModal } from '@/plugins/alert-modal/alert-modal'
  import { formatMoney } from '@/utils/money'
  import ReportsTable from '@/views/reports/v2/table/ReportsTable.vue'
  import { formatPostgresDate } from '@/utils/date'
  import User from '@/models/user/User'
  
  // i18n
  const { t } = useI18n({
    messages: {
      en: {
        vendorsOutstandingBalances: 'Vendors Outstanding Balances',
        name: 'Name',
        outstandingBalances: 'Outstanding Balances',
        totalBalance: 'Total Balance',
        totalBalances: 'Total Balances',
        totalVendorsWithBalances: 'Vendors With Balances'
      },
      ar: {
        vendorsOutstandingBalances: 'أرصدة الموردين المستحقة',
        name: 'الاسم',
        outstandingBalances: 'Outstanding Balances',
        totalBalance: 'Total Balance',
        totalBalances: 'Total Balances',
        totalVendorsWithBalances: 'Vendors With Balances'
      }
    }
  })
  
  // Data
  const rtable = ref<any>()
  const columnDefs = ref<ColDef[]>([])
  
  const totalBalances = ref(0)
  const totalVendorsWithBalances = ref(0)
  
  const http = useHTTP()
  const route = useRoute()
  const router = useRouter()
  const alertModal = useAlertModal()
  
  onBeforeMount(async () => {
    columnDefs.value = [
      {
        headerName: t('name'),
        field: 'name',
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
      {
        headerName: t('totalBalance'),
        field: 'total_balance',
        valueFormatter: ({ data }) => {
          if (!data) return ''
          return `${formatMoney(data.total_balance, 'IQD')}`
        }
      }
    ]
  })
  
  function onDataLoaded(data: any) {
    totalBalances.value = 0
    totalVendorsWithBalances.value = 0
  
    for (let i = 0; i < data.length; i++) {
      totalBalances.value += data[i].total_balance
      totalVendorsWithBalances.value += 1
    }
  }
  </script>
  